import React, {memo} from 'react';

import {getImageUrl} from '../../../auth/utils/helpers';
import {REACTION_ICON_SIZES} from '../constants';

import styles from '../reactions.module.css';

const ReactionIcon = memo(({
  type,
  size = REACTION_ICON_SIZES.MEDIUM
}) => (
  <img
    src={getImageUrl(`icons/reactions/${type}.svg`)}
    width={size}
    height={size}
    /* eslint-disable-next-line no-warning-comments */
    alt="Comment reaction" // TODO @rb get correct alt
    className={styles.reactionIcon}
  />
));

export default ReactionIcon;
